import type { ThemeOptions } from "@mui/material/styles";
import { componentOverrides } from "./components";
import palettes from "./palettes";
import { typographyConfig } from "./typography";

/**
 * Intentionally no `defaultColorScheme` is specified.
 * According to MUI v7 documentation, when `cssVariables` is enabled with
 * `colorSchemeSelector: 'class'` (or 'data') and no explicit `defaultColorScheme` is specified,
 * MUI defaults to 'system' mode, which automatically follows the user's operating system preference.
 */

export const createThemeSettings = (): ThemeOptions => ({
  cssVariables: {
    colorSchemeSelector: "class",
    nativeColor: true, // https://mui.com/material-ui/migration/upgrade-to-native-color/#handling-javascript-color-manipulation
  },
  colorSchemes: {
    light: { palette: palettes.light as any },
    dark: { palette: palettes.dark as any },
  },
  components: componentOverrides as any,
  typography: typographyConfig,
});
